import * as React from "react";
import { formatRut } from "../../../../helperComponents/InputRut/rutValidate";
import { fullName } from "../../../../helperComponents";

var ClientTable = function ClientTable(props) {
  var _user$region, _user$comuna;

  var user = props.user;
  return /*#__PURE__*/React.createElement("tbody", {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Nombre:"), /*#__PURE__*/React.createElement("td", null, user ? "".concat(fullName(user)) : "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Rut"), /*#__PURE__*/React.createElement("td", null, user ? formatRut(user.rut || "") : "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Email"), /*#__PURE__*/React.createElement("td", null, user !== null && user !== void 0 && user.email ? "".concat(user.email) : "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Tel\xE9fono"), /*#__PURE__*/React.createElement("td", null, user !== null && user !== void 0 && user.phone_code_number && user !== null && user !== void 0 && user.phone ? "".concat(user.phone_code_number, " ").concat(user.phone) : "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Direcci\xF3n"), /*#__PURE__*/React.createElement("td", null, user !== null && user !== void 0 && user.street ? "".concat(user.street) : "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Regi\xF3n"), /*#__PURE__*/React.createElement("td", null, user !== null && user !== void 0 && user.region ? "".concat((_user$region = user.region) === null || _user$region === void 0 ? void 0 : _user$region.name) : "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Comuna"), /*#__PURE__*/React.createElement("td", null, user !== null && user !== void 0 && user.comuna ? "".concat((_user$comuna = user.comuna) === null || _user$comuna === void 0 ? void 0 : _user$comuna.name) : "-")));
};

export default ClientTable;